import React, { Component } from "react";
import { PageHeader, Spin, Card, Row, Col, Tag, Tooltip, message } from "antd";
import { Typography } from "antd";

import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";

moment.locale("es");

const { Text } = Typography;

const MODO_LABEL = { 1: "Ciego", 2: "Semi-ciego", 3: "Abierto" };

const TH_BASE = { background: "#e6f7fa", color: "#006d75", fontWeight: 600, padding: "10px 12px", whiteSpace: "nowrap" };
const TH_LEFT = TH_BASE;
const TH_NUM = (extra = {}) => ({ ...TH_BASE, textAlign: "right", ...extra });
const TH_CENTER = (extra = {}) => ({ ...TH_BASE, textAlign: "center", ...extra });
const TD_BASE = { padding: "8px 12px", verticalAlign: "middle" };
const TD_LEFT = TD_BASE;
const TD_RIGHT = (extra = {}) => ({ ...TD_BASE, textAlign: "right", ...extra });
const TD_CENTER = (extra = {}) => ({ ...TD_BASE, textAlign: "center", ...extra });

const tagEstado = (estado) => {
    switch (estado) {
        case 0: return <Tag color="red">Cancelada</Tag>;
        case 1: return <Tag color="default">Pendiente</Tag>;
        case 2: return <Tag color="blue">Contada</Tag>;
        case 3: return <Tag color="green">Aprobada</Tag>;
        default: return <Tag>—</Tag>;
    }
};

// Solo las claves de las ubicaciones donde el insumo tiene existencia hoy, sin cantidades (mismo criterio
// que en ContarOrdenDeConteo: revelar cantidades filtraria la existencia del sistema).
const textoUbicaciones = (item) => {
    const claves = (item.ubicaciones || []).map((u) => u.clave).filter(Boolean);
    if (item.sinUbicacion) claves.push("Sin ubicación");
    return claves.length > 0 ? claves.join(", ") : "—";
};

const detalleUbicaciones = (item) => {
    const lineas = (item.ubicaciones || []).map((u) =>
        u.nombre ? `${u.clave} - ${u.nombre}` : u.clave
    ).filter(Boolean);
    if (item.sinUbicacion) lineas.push("Sin ubicación asignada");
    if (lineas.length === 0) return null;
    return (
        <div>
            {lineas.map((linea, indice) => (
                <div key={indice}>{linea}</div>
            ))}
        </div>
    );
};

const tagInsumo = (item) => {
    if (item.resolucion?.cantidadFinal != null) return <Tag color="green">Resuelto</Tag>;
    if (item.requiereReconteo) return <Tag color="orange">Reconteo</Tag>;
    if (item.conteos?.length > 0) return <Tag color="blue">Contado</Tag>;
    return <Tag color="default">Pendiente</Tag>;
};

class VerOrdenDeConteo extends Component {
    state = {
        loading: false,
        orden: null,
        id: this.props.match.params.id,
    };

    componentDidMount() {
        this.consultarOrden();
    }

    async consultarOrden() {
        this.setState({ loading: true });
        try {
            const res = await axios.post(
                "ordenesDeConteo/selectOrdenDeConteo",
                {
                    empresaId: this.props.empresaId,
                    ordenDeConteoId: this.state.id,
                },
                { headers: this.props.headersToken }
            );
            if (res.data.success === 2) {
                this.setState({ orden: res.data.orden });
            } else {
                message.error("No se encontró la orden");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loading: false });
    }

    atras() {
        this.props.history.goBack();
    }

    render() {
        const { loading, orden } = this.state;

        const maxIntento = orden
            ? (orden.insumos || []).reduce(
                  (max, i) => Math.max(max, i.conteos?.length || 0),
                  0
              )
            : 0;

        // La columna solo aplica si la empresa usa WMS y algun insumo de la orden trae ubicacion.
        const mostrarUbicacion = !!this.props.moduloWms
            && (orden?.insumos || []).some((i) => i.ubicaciones?.length > 0 || i.sinUbicacion);

        // Mismo criterio: la columna aparece solo si algun insumo de la orden tiene codigo de barras
        // capturado, para no ensanchar la tabla con una columna de puros guiones.
        const mostrarCodigoBarras = (orden?.insumos || []).some((i) => !!i.codigoBarras);

        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={`Orden de Conteo${orden ? `: ${orden.serieNumero}` : ""}`}
                    tags={orden ? tagEstado(orden.estado) : null}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background">
                    <Spin spinning={loading}>
                        {orden && (
                            <>
                                <Card
                                    style={{ marginBottom: 16, borderRadius: 8, border: "1px solid #d9f2f5", background: "#f0f9fa" }}
                                    bodyStyle={{ padding: "12px 18px" }}
                                >
                                    <Row gutter={[24, 8]}>
                                        <Col>
                                            <Text type="secondary" style={{ fontSize: 11 }}>Responsable</Text>
                                            <br />
                                            <Text style={{ fontSize: 13 }}>{orden.responsableNombre || "—"}</Text>
                                        </Col>
                                        <Col>
                                            <Text type="secondary" style={{ fontSize: 11 }}>Supervisor</Text>
                                            <br />
                                            <Text style={{ fontSize: 13 }}>{orden.supervisorNombre || "—"}</Text>
                                        </Col>
                                        <Col>
                                            <Text type="secondary" style={{ fontSize: 11 }}>Proyecto</Text>
                                            <br />
                                            <Text style={{ fontSize: 13 }}>{orden.proyectoNombre || "—"}</Text>
                                        </Col>
                                        <Col>
                                            <Text type="secondary" style={{ fontSize: 11 }}>Modo</Text>
                                            <br />
                                            <Tag color="cyan" style={{ marginTop: 3 }}>{MODO_LABEL[orden.modoConteo] || "—"}</Tag>
                                        </Col>
                                        {orden.fechaInicio && (
                                            <Col>
                                                <Text type="secondary" style={{ fontSize: 11 }}>Inicio</Text>
                                                <br />
                                                <Text style={{ fontSize: 13 }}>{moment(orden.fechaInicio).format("DD/MM/YYYY HH:mm")}</Text>
                                            </Col>
                                        )}
                                        {orden.fechaTermino && (
                                            <Col>
                                                <Text type="secondary" style={{ fontSize: 11 }}>Término</Text>
                                                <br />
                                                <Text style={{ fontSize: 13 }}>{moment(orden.fechaTermino).format("DD/MM/YYYY HH:mm")}</Text>
                                            </Col>
                                        )}
                                        {orden.fechaVigencia && (
                                            <Col>
                                                <Text type="secondary" style={{ fontSize: 11 }}>Vigencia</Text>
                                                <br />
                                                <Text style={{ fontSize: 13, color: (orden.estado !== 3 && moment().startOf("day").isAfter(moment(orden.fechaVigencia).startOf("day"))) ? "#f5222d" : undefined }}>
                                                    {moment(orden.fechaVigencia).format("DD/MM/YYYY")}
                                                </Text>
                                            </Col>
                                        )}
                                    </Row>
                                </Card>

                                <div style={{ overflowX: "auto" }}>
                                    <table className="table" style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                        <thead>
                                            <tr>
                                                <th className="th-border" style={TH_LEFT}>Insumo</th>
                                                {mostrarCodigoBarras && (
                                                    <th className="th-border" style={TH_LEFT}>Cód. barras</th>
                                                )}
                                                {mostrarUbicacion && (
                                                    <th className="th-border" style={TH_LEFT}>Ubicación</th>
                                                )}
                                                {Array.from({ length: maxIntento }, (_, i) => (
                                                    <th key={i} className="th-border" style={TH_NUM({ width: "11%" })}>
                                                        {i === 0 ? "Conteo 1" : `Reconteo ${i}`}
                                                    </th>
                                                ))}
                                                <th className="th-border" style={TH_NUM({ width: "11%" })}>Dif. final</th>
                                                <th className="th-border" style={TH_NUM({ width: "11%" })}>Snapshot</th>
                                                <th className="th-border" style={TH_NUM({ width: "11%" })}>% Dif.</th>
                                                <th className="th-border" style={TH_CENTER({ width: "10%" })}>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(orden.insumos || []).map((item, idx) => {
                                                const ultimo = item.conteos?.[item.conteos.length - 1];
                                                const diff = item.resolucion?.diferenciaFinal ?? ultimo?.diferenciaVsSnapshot;
                                                const snapshot = item.resolucion?.snapshotFinal;
                                                const pctDiff =
                                                    diff != null && snapshot != null && snapshot !== 0
                                                        ? ((diff / snapshot) * 100).toFixed(2)
                                                        : null;

                                                const rowBg = item.conteos?.length > 0
                                                    ? diff === 0 ? "#f6ffed" : diff != null ? "#fff1f0" : "#fffbe6"
                                                    : undefined;

                                                const diffColor = diff === 0 ? "#52c41a" : diff != null ? "#f5222d" : undefined;
                                                const pctColor = pctDiff !== null && parseFloat(pctDiff) === 0 ? "#52c41a" : pctDiff !== null ? "#f5222d" : undefined;

                                                return (
                                                    <tr key={idx} style={rowBg ? { background: rowBg } : undefined}>
                                                        <td className="td-border" style={TD_LEFT}>{item.nombre || "—"}</td>
                                                        {mostrarCodigoBarras && (
                                                            <td className="td-border" style={TD_LEFT}>
                                                                <span style={{ color: "#595959", fontFamily: "monospace" }}>
                                                                    {item.codigoBarras || "—"}
                                                                </span>
                                                            </td>
                                                        )}
                                                        {mostrarUbicacion && (() => {
                                                            const detalle = detalleUbicaciones(item);
                                                            const texto = (
                                                                <span style={{ color: "#595959" }}>{textoUbicaciones(item)}</span>
                                                            );
                                                            return (
                                                                <td className="td-border" style={TD_LEFT}>
                                                                    {detalle ? <Tooltip title={detalle}>{texto}</Tooltip> : texto}
                                                                </td>
                                                            );
                                                        })()}
                                                        {Array.from({ length: maxIntento }, (_, i) => (
                                                            <td key={i} className="td-border" style={TD_RIGHT({ color: "#595959" })}>
                                                                {item.conteos?.[i]?.cantidadContada ?? "—"}
                                                            </td>
                                                        ))}
                                                        <td className="td-border" style={TD_RIGHT({ fontWeight: 600, color: diffColor })}>
                                                            {diff != null ? (diff > 0 ? `+${diff}` : diff) : "—"}
                                                        </td>
                                                        <td className="td-border" style={TD_RIGHT()}>{snapshot ?? "—"}</td>
                                                        <td className="td-border" style={TD_RIGHT({ fontWeight: 600, color: pctColor })}>
                                                            {pctDiff !== null ? `${parseFloat(pctDiff) > 0 ? "+" : ""}${pctDiff}%` : "—"}
                                                        </td>
                                                        <td className="td-border" style={TD_CENTER()}>{tagInsumo(item)}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    moduloWms: state.empresa.moduloWms,
});

export default connect(mapStateToProps)(VerOrdenDeConteo);
